// @generated by scripts/gen-name-locales.js — DO NOT EDIT BY HAND.
// Hindi full names are derived from PyJHora's src/jhora/lang/list_values_hi.txt; all of
// Sanskrit and the rasi/graha abbreviations come from scripts/name-locales.manual.json.
// Re-run `npm run gen:names` after changing either.
//
// Keys are the backend's canonical English names (astrology/engine.py). A missing key
// is not an error — localizeName() falls back to the English input.

export const NAME_ORDER = {
  rasis: [
    "Aries",
    "Taurus",
    "Gemini",
    "Cancer",
    "Leo",
    "Virgo",
    "Libra",
    "Scorpio",
    "Sagittarius",
    "Capricorn",
    "Aquarius",
    "Pisces",
  ],
  nakshatras: [
    "Ashwini",
    "Bharani",
    "Krittika",
    "Rohini",
    "Mrigashira",
    "Ardra",
    "Punarvasu",
    "Pushya",
    "Ashlesha",
    "Magha",
    "Purva Phalguni",
    "Uttara Phalguni",
    "Hasta",
    "Chitra",
    "Swati",
    "Vishakha",
    "Anuradha",
    "Jyeshtha",
    "Mula",
    "Purva Ashadha",
    "Uttara Ashadha",
    "Shravana",
    "Dhanishta",
    "Shatabhisha",
    "Purva Bhadrapada",
    "Uttara Bhadrapada",
    "Revati",
  ],
  grahas: ["Sun", "Moon", "Mars", "Mercury", "Jupiter", "Venus", "Saturn", "Rahu", "Ketu"],
};

const NAME_LOCALES = {
  en: {
    rasis: {
      Aries: "Aries",
      Taurus: "Taurus",
      Gemini: "Gemini",
      Cancer: "Cancer",
      Leo: "Leo",
      Virgo: "Virgo",
      Libra: "Libra",
      Scorpio: "Scorpio",
      Sagittarius: "Sagittarius",
      Capricorn: "Capricorn",
      Aquarius: "Aquarius",
      Pisces: "Pisces",
    },
    nakshatras: {
      Ashwini: "Ashwini",
      Bharani: "Bharani",
      Krittika: "Krittika",
      Rohini: "Rohini",
      Mrigashira: "Mrigashira",
      Ardra: "Ardra",
      Punarvasu: "Punarvasu",
      Pushya: "Pushya",
      Ashlesha: "Ashlesha",
      Magha: "Magha",
      "Purva Phalguni": "Purva Phalguni",
      "Uttara Phalguni": "Uttara Phalguni",
      Hasta: "Hasta",
      Chitra: "Chitra",
      Swati: "Swati",
      Vishakha: "Vishakha",
      Anuradha: "Anuradha",
      Jyeshtha: "Jyeshtha",
      Mula: "Mula",
      "Purva Ashadha": "Purva Ashadha",
      "Uttara Ashadha": "Uttara Ashadha",
      Shravana: "Shravana",
      Dhanishta: "Dhanishta",
      Shatabhisha: "Shatabhisha",
      "Purva Bhadrapada": "Purva Bhadrapada",
      "Uttara Bhadrapada": "Uttara Bhadrapada",
      Revati: "Revati",
    },
    grahas: {
      Sun: "Sun",
      Moon: "Moon",
      Mars: "Mars",
      Mercury: "Mercury",
      Jupiter: "Jupiter",
      Venus: "Venus",
      Saturn: "Saturn",
      Rahu: "Rahu",
      Ketu: "Ketu",
    },
    rasisAbbr: {
      Aries: "Ar",
      Taurus: "Ta",
      Gemini: "Ge",
      Cancer: "Cn",
      Leo: "Le",
      Virgo: "Vi",
      Libra: "Li",
      Scorpio: "Sc",
      Sagittarius: "Sg",
      Capricorn: "Cp",
      Aquarius: "Aq",
      Pisces: "Pi",
    },
    nakshatrasAbbr: {
      Ashwini: "Asw",
      Bharani: "Bha",
      Krittika: "Kri",
      Rohini: "Roh",
      Mrigashira: "Mrig",
      Ardra: "Ardr",
      Punarvasu: "Puna",
      Pushya: "Push",
      Ashlesha: "Asre",
      Magha: "Magh",
      "Purva Phalguni": "PPha",
      "Uttara Phalguni": "UPha",
      Hasta: "Hast",
      Chitra: "Chit",
      Swati: "Swat",
      Vishakha: "Visa",
      Anuradha: "Anu",
      Jyeshtha: "Jye",
      Mula: "Mool",
      "Purva Ashadha": "PSha",
      "Uttara Ashadha": "USha",
      Shravana: "Srav",
      Dhanishta: "Dhan",
      Shatabhisha: "Sat",
      "Purva Bhadrapada": "PBha",
      "Uttara Bhadrapada": "UBha",
      Revati: "Rev",
    },
    grahasAbbr: {
      Sun: "Su",
      Moon: "Mo",
      Mars: "Ma",
      Mercury: "Me",
      Jupiter: "Ju",
      Venus: "Ve",
      Saturn: "Sa",
      Rahu: "Ra",
      Ketu: "Ke",
    },
  },
  hi: {
    rasis: {
      Aries: "मेष",
      Taurus: "वृषभ",
      Gemini: "मिथुन",
      Cancer: "कर्क",
      Leo: "सिंह",
      Virgo: "कन्या",
      Libra: "तुला",
      Scorpio: "वृश्चिक",
      Sagittarius: "धनु",
      Capricorn: "मकर",
      Aquarius: "कुंभ",
      Pisces: "मीन",
    },
    nakshatras: {
      Ashwini: "अश्विनि",
      Bharani: "भरणी",
      Krittika: "कृत्तिका",
      Rohini: "रोहिणी",
      Mrigashira: "म्रृगशीर्षा",
      Ardra: "आर्द्रा",
      Punarvasu: "पुनर्वसु",
      Pushya: "पुष्य",
      Ashlesha: "अश्लेषा",
      Magha: "मघा",
      "Purva Phalguni": "पूर्व फल्गुनी",
      "Uttara Phalguni": "उत्तर फल्गुनी",
      Hasta: "हस्त",
      Chitra: "चित्रा",
      Swati: "स्वाति",
      Vishakha: "विशाखा",
      Anuradha: "अनुराधा",
      Jyeshtha: "ज्येष्ठा",
      Mula: "मूल",
      "Purva Ashadha": "पूर्वाषाढ़ा",
      "Uttara Ashadha": "उत्तराषाढ़ा",
      Shravana: "श्रवण",
      Dhanishta: "धनिष्ठा",
      Shatabhisha: "शतभिषा",
      "Purva Bhadrapada": "पूर्वभाद्र",
      "Uttara Bhadrapada": "उत्तरभाद्र",
      Revati: "रेवती",
    },
    grahas: {
      Sun: "सूर्य",
      Moon: "चंद्रमा",
      Mars: "मंगल",
      Mercury: "बुध",
      Jupiter: "बृहस्पति",
      Venus: "शुक्र",
      Saturn: "शनि",
      Rahu: "राहु",
      Ketu: "केतु",
    },
    nakshatrasAbbr: {
      Ashwini: "अश्वि",
      Bharani: "भर",
      Krittika: "कृत्त",
      Rohini: "रोहि",
      Mrigashira: "म्रृग",
      Ardra: "आर्द्र",
      Punarvasu: "पुनर्व",
      Pushya: "पुष्य",
      Ashlesha: "अश्ले",
      Magha: "मघा",
      "Purva Phalguni": "पू.फ",
      "Uttara Phalguni": "उ.फ",
      Hasta: "हस्त",
      Chitra: "चित्रा",
      Swati: "स्वा",
      Vishakha: "विशा",
      Anuradha: "अनु",
      Jyeshtha: "ज्ये",
      Mula: "मूल",
      "Purva Ashadha": "पू.षा",
      "Uttara Ashadha": "उ.षा",
      Shravana: "श्रव",
      Dhanishta: "धनि",
      Shatabhisha: "शत",
      "Purva Bhadrapada": "पू.भा",
      "Uttara Bhadrapada": "उ.भा",
      Revati: "रेव",
    },
    rasisAbbr: {
      Aries: "मेष",
      Taurus: "वृष",
      Gemini: "मिथ",
      Cancer: "कर्क",
      Leo: "सिंह",
      Virgo: "कन्या",
      Libra: "तुला",
      Scorpio: "वृश्",
      Sagittarius: "धनु",
      Capricorn: "मकर",
      Aquarius: "कुंभ",
      Pisces: "मीन",
    },
    grahasAbbr: {
      Sun: "सू",
      Moon: "चं",
      Mars: "मं",
      Mercury: "बु",
      Jupiter: "गु",
      Venus: "शु",
      Saturn: "श",
      Rahu: "रा",
      Ketu: "के",
    },
  },
  sa: {
    rasis: {
      Aries: "मेष",
      Taurus: "वृषभ",
      Gemini: "मिथुन",
      Cancer: "कर्कट",
      Leo: "सिंह",
      Virgo: "कन्या",
      Libra: "तुला",
      Scorpio: "वृश्चिक",
      Sagittarius: "धनुस्",
      Capricorn: "मकर",
      Aquarius: "कुम्भ",
      Pisces: "मीन",
    },
    nakshatras: {
      Ashwini: "अश्विनी",
      Bharani: "भरणी",
      Krittika: "कृत्तिका",
      Rohini: "रोहिणी",
      Mrigashira: "मृगशीर्ष",
      Ardra: "आर्द्रा",
      Punarvasu: "पुनर्वसु",
      Pushya: "पुष्य",
      Ashlesha: "आश्लेषा",
      Magha: "मघा",
      "Purva Phalguni": "पूर्वफल्गुनी",
      "Uttara Phalguni": "उत्तरफल्गुनी",
      Hasta: "हस्त",
      Chitra: "चित्रा",
      Swati: "स्वाती",
      Vishakha: "विशाखा",
      Anuradha: "अनुराधा",
      Jyeshtha: "ज्येष्ठा",
      Mula: "मूल",
      "Purva Ashadha": "पूर्वाषाढा",
      "Uttara Ashadha": "उत्तराषाढा",
      Shravana: "श्रवण",
      Dhanishta: "धनिष्ठा",
      Shatabhisha: "शतभिषक्",
      "Purva Bhadrapada": "पूर्वभाद्रपदा",
      "Uttara Bhadrapada": "उत्तरभाद्रपदा",
      Revati: "रेवती",
    },
    grahas: {
      Sun: "सूर्य",
      Moon: "चन्द्र",
      Mars: "मङ्गल",
      Mercury: "बुध",
      Jupiter: "बृहस्पति",
      Venus: "शुक्र",
      Saturn: "शनि",
      Rahu: "राहु",
      Ketu: "केतु",
    },
    nakshatrasAbbr: {
      Ashwini: "अश्वि",
      Bharani: "भर",
      Krittika: "कृत्त",
      Rohini: "रोहि",
      Mrigashira: "म्रृग",
      Ardra: "आर्द्र",
      Punarvasu: "पुनर्व",
      Pushya: "पुष्य",
      Ashlesha: "अश्ले",
      Magha: "मघा",
      "Purva Phalguni": "पू.फ",
      "Uttara Phalguni": "उ.फ",
      Hasta: "हस्त",
      Chitra: "चित्रा",
      Swati: "स्वा",
      Vishakha: "विशा",
      Anuradha: "अनु",
      Jyeshtha: "ज्ये",
      Mula: "मूल",
      "Purva Ashadha": "पू.षा",
      "Uttara Ashadha": "उ.षा",
      Shravana: "श्रव",
      Dhanishta: "धनि",
      Shatabhisha: "शत",
      "Purva Bhadrapada": "पू.भा",
      "Uttara Bhadrapada": "उ.भा",
      Revati: "रेव",
    },
    rasisAbbr: {
      Aries: "मेष",
      Taurus: "वृष",
      Gemini: "मिथ",
      Cancer: "कर्क",
      Leo: "सिंह",
      Virgo: "कन्या",
      Libra: "तुला",
      Scorpio: "वृश्",
      Sagittarius: "धनु",
      Capricorn: "मकर",
      Aquarius: "कुम्भ",
      Pisces: "मीन",
    },
    grahasAbbr: {
      Sun: "सू",
      Moon: "चं",
      Mars: "मं",
      Mercury: "बु",
      Jupiter: "गु",
      Venus: "शु",
      Saturn: "श",
      Rahu: "रा",
      Ketu: "के",
    },
  },
};

export default NAME_LOCALES;
